"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditablePagesPage = void 0;
const AppPage_1 = require("@juvare/common-web-ui/AppPage");
const AppPageHeader1_1 = require("@juvare/common-web-ui/AppPageHeader1");
const AppPageHeader2_1 = require("@juvare/common-web-ui/AppPageHeader2");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const shared_1 = require("../../../../backend/features/editable-pages/shared");
const components_1 = require("../../../../ui/components");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const useEditablePagesStorage_1 = require("../hooks/useEditablePagesStorage");
const EditablePagesForm_1 = require("./EditablePagesForm");
const EditablePagesPage = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    const storage = (0, useEditablePagesStorage_1.useEditablePagesStorage)();
    const [selectedPage, setSelectedPage] = react_1.default.useState();
    const [create, setCreate] = react_1.default.useState(false);
    const appTitle = props.title ?? t('editablePages.pages');
    const [reloadFlag, setReloadFlag] = react_1.default.useState();
    if (selectedPage || create) {
        return (react_1.default.createElement(AppPage_1.AppPage, { header: react_1.default.createElement(AppPageHeader2_1.AppPageHeader2, { title: appTitle, subTitle: selectedPage ? [selectedPage.data.title ?? selectedPage.data.label] : t('common.new'), onBack: () => navigationContext.navigate(() => {
                    setSelectedPage(undefined);
                    setCreate(false);
                    setReloadFlag({});
                }, true) }), contentWidth: 800, contentPadding: 2, contentScrollable: true },
            react_1.default.createElement(EditablePagesForm_1.EditablePagesForm, { data: selectedPage?.data ?? {}, tags: props.tags, onSubmit: (data) => {
                    return (selectedPage ? updatePage(storage, selectedPage.id, data) : createPage(storage, data)).then((response) => {
                        setReloadFlag({});
                        setCreate(false);
                        setSelectedPage(undefined);
                        return response;
                    });
                } })));
    }
    else {
        const labelColumn = {
            name: 'label',
            label: t('editablePages.editablePagesForm.descriptions.label'),
            render: (row) => (react_1.default.createElement(material_1.Typography, { sx: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-word',
                    WebkitLineClamp: 4,
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                } }, row.columns.label)),
        };
        return (react_1.default.createElement(AppPage_1.AppPage, { header: react_1.default.createElement(AppPageHeader1_1.AppPageHeader1, { title: props.title ?? t('editablePages.page'), onCreate: props.canCreate ? () => setCreate(true) : undefined }) },
            react_1.default.createElement(components_1.EntityTable, { entity: shared_1.editablePageEntityName, columns: [
                    labelColumn,
                    { name: 'order', label: t('editablePages.editablePagesForm.labels.order'), sortable: true },
                    {
                        name: 'active',
                        label: t('editablePages.editablePagesForm.labels.active'),
                        render: (row) => (row.columns.active ? t('common.yes') : t('common.no')),
                    },
                ], mobileColumns: [labelColumn], fullTextSearchField: 'search', reloadFlag: reloadFlag, onSelectRow: (row) => {
                    storage.get(row.id).then((response) => setSelectedPage(response));
                }, rowMenuItems: props.canDelete
                    ? [
                        {
                            label: t('common.delete'),
                            onClick: (row) => showDeleteDialog({ storage: storage, page: row, onSuccess: () => setReloadFlag({}), t }),
                        },
                    ]
                    : undefined })));
    }
};
exports.EditablePagesPage = EditablePagesPage;
function showDeleteDialog(params) {
    (0, DialogHelper_1.showConfirmDialog)({
        title: params.t('editablePages.deletePage'),
        content: react_1.default.createElement(material_1.Typography, null, params.t('editablePages.confirmDelete')),
        confirmLabel: params.t('common.delete'),
        onConfirm: () => deletePage(params.storage, params.page.id)
            .then((response) => params.onSuccess(response))
            .catch(DialogHelper_1.handleErrorDialog),
    });
}
function createPage(storage, data) {
    return storage.post({
        action: 'create',
        data: {
            ...data,
            tags: data?.tags ?? [],
        },
    });
}
function updatePage(storage, id, data) {
    return storage.post({
        action: 'partial-update',
        id: id,
        data: {
            ...data,
        },
    });
}
function deletePage(storage, id) {
    return storage.post({
        action: 'delete',
        id: id,
    });
}
